/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:52724b2d-7d44-443d-801e-a798d54e7519",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_lWVOg6pwR",
    "aws_user_pools_web_client_id": "6heod3cr73724mggm78635qnqd",
    "oauth": {},
    "aws_user_files_s3_bucket": "carritofacil90479689cc3f4dc0b9dd900688f30f0e01929-prod",
    "aws_user_files_s3_bucket_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://iv5n5vueezcvdkoyw2nziymvkq.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "paykuapi",
            "endpoint": "https://pxjyafxdqc.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        },
        {
            "name": "carritoticketsapi",
            "endpoint": "https://n724u4uw1k.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        },
        {
            "name": "carritotransferencia",
            "endpoint": "https://8u4lc92dx3.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        },
        {
            "name": "carritologger",
            "endpoint": "https://pxl8kjehub.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        },
        {
            "name": "carritoproductos",
            "endpoint": "https://8xp8hv4tb3.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        },
        {
            "name": "carritofacilapi",
            "endpoint": "https://en6tsuvwpg.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        }
    ]
};


export default awsmobile;
